import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CheckoutInterceptor } from './http-interceptors';

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: CheckoutInterceptor,
      multi: true,
    },
  ],
})
export class CheckoutFeatureEagerModule {}
